import { Item } from "./InventoryContext";

export interface RefreshLinesResult {
	lines: Item[];
	updated: number;
	missing: number;
}

/**
 * Refresh counted lines from the depot's items: name, code, unit value, system
 * stock, sector, category and the fractional flag are taken from the catalog.
 * The item id and the count stay, they are what the counter entered.
 * A line whose item is no longer in the depot is left untouched and counted as missing.
 */
export const refreshInventoryLines = (
	lines: readonly Item[],
	items: readonly any[],
): RefreshLinesResult => {
	const sourceById = new Map<number, any>(items.map((item: any) => [Number(item.id), item]));
	let updated = 0;
	let missing = 0;

	const next = lines.map((line) => {
		const source = sourceById.get(Number(line.id));
		if (!source) {
			missing += 1;
			return line;
		}
		updated += 1;
		return new Item({
			...line,
			id: line.id,
			quantity: line.quantity,
			item_code: source.ItemCode ?? line.item_code,
			item: source.ItemName ?? line.item,
			price: source.CostPrice ?? line.price,
			stock: source.Stock ?? line.stock,
			sector: source.Sector ?? line.sector,
			category: source.Category ?? line.category,
			isFractional: source.IsFractional === true,
		});
	});

	return { lines: next, updated, missing };
};
